package co.maytes.standupbot.dashboard.features.standupruns

import co.maytes.standupbot.shared.dto.standuprun.StandupRunStatusDto
import co.maytes.standupbot.shared.util.RelativeTime
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

object RunStatusRules {
    const val WORKING_POLL_INTERVAL_MS = 5_000L
    const val DRAFT_POLL_INTERVAL_MS = 15_000L

    private const val NOON_HOUR = 12
    private const val MINUTES_PAD = 2

    fun pollIntervalMs(status: StandupRunStatusDto?): Long? =
        when (status) {
            StandupRunStatusDto.PENDING, StandupRunStatusDto.GENERATING -> WORKING_POLL_INTERVAL_MS
            StandupRunStatusDto.DRAFTED -> DRAFT_POLL_INTERVAL_MS
            else -> null
        }

    fun isWorking(status: StandupRunStatusDto): Boolean = status == StandupRunStatusDto.PENDING || status == StandupRunStatusDto.GENERATING

    fun canRegenerate(status: StandupRunStatusDto): Boolean = status == StandupRunStatusDto.POSTED || status == StandupRunStatusDto.NO_ACTIVITY

    fun canRerun(status: StandupRunStatusDto): Boolean = status != StandupRunStatusDto.DRAFTED

    fun showsNoActivityBanner(
        status: StandupRunStatusDto,
        sectionCount: Int,
    ): Boolean =
        status == StandupRunStatusDto.NO_ACTIVITY ||
            (sectionCount == 0 && (status == StandupRunStatusDto.POSTED || status == StandupRunStatusDto.SKIPPED))

    fun clockLabel(
        instant: Instant,
        zone: TimeZone,
    ): String {
        val time = instant.toLocalDateTime(zone)
        val hour12 = (time.hour % NOON_HOUR).let { if (it == 0) NOON_HOUR else it }
        val period = if (time.hour < NOON_HOUR) "AM" else "PM"
        return "$hour12:${time.minute.toString().padStart(MINUTES_PAD, '0')} $period"
    }

    fun canActOnDraft(status: StandupRunStatusDto): Boolean = status == StandupRunStatusDto.DRAFTED

    fun postNowMessage(
        posted: Boolean,
        status: StandupRunStatusDto,
    ): String =
        when {
            posted -> "Posted to Slack"
            status == StandupRunStatusDto.POSTED -> "This standup was already posted"
            else -> "It is being posted right now"
        }

    const val DISCARD_TITLE = "Discard this draft?"
    const val DISCARD_BODY =
        "Nothing will be posted to Slack for this day. People who were sent a draft are told it was discarded."

    fun draftHeadline(postsAt: String): String = "Draft: posts at $postsAt"

    fun draftTimingLabel(
        postsAt: Instant,
        now: Instant,
    ): String = if (postsAt > now) "posts ${RelativeTime.formatFuture(postsAt, now)}" else "posting shortly"

    const val DRAFT_EXPLANATION = "Nothing has been posted to Slack yet. People with activity can review their line first; the standup posts on schedule either way."
}
